import { TrackingEventIds as BaseTrackingEventIds } from '../../common/tracking/tracking-event-ids.model';

export const TrackingEventIds = {
  ...BaseTrackingEventIds,
  OPEN_DASHBOARD_DATA_TABLE_DIALOG: 'open_dashboard_data_table_dialog'
};
